(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FRNKTurn = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function init(container) {
    if (!container || container.dataset.turnReady === 'true') return;
    const frames = Array.from(container.querySelectorAll('[data-frame], .turn-frame'));
    if (frames.length < 2) return;
    container.dataset.turnReady = 'true';
    const section = container.closest('.turn-section');
    const button = section.querySelector('[data-turn-toggle]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    let visible = !('IntersectionObserver' in window);
    let paused = false;
    let index = 0;
    let timer = null;
    let disposed = false;
    function allowed() { return !disposed && visible && !document.hidden && !paused && !motion.matches && !(connection && connection.saveData); }
    function preload() {
      frames.forEach(function (frame) { frame.loading = 'eager'; });
    }
    function sync() {
      clearTimeout(timer);
      timer = null;
      if (button) {
        button.hidden = motion.matches || Boolean(connection && connection.saveData);
        button.setAttribute('aria-label', paused ? 'Play vessel rotation' : 'Pause vessel rotation');
      }
      if (!allowed()) return;
      preload();
      timer = setTimeout(function tick() {
        if (!allowed()) return;
        const next = (index + 1) % frames.length;
        if (frames[next].complete && frames[next].naturalWidth > 0) {
          frames[index].hidden = true;
          frames[next].hidden = false;
          index = next;
        }
        timer = setTimeout(tick, 150);
      }, 150);
    }
    function toggle() { paused = !paused; sync(); }
    frames.forEach(function (frame, i) { frame.hidden = i !== 0; });
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries.some(function (entry) { return entry.isIntersecting; });
        sync();
      });
      observer.observe(container);
    }
    if (button) { button.hidden = false; button.addEventListener('click', toggle); }
    motion.addEventListener('change', sync);
    if (connection && connection.addEventListener) connection.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    function unload(event) {
      if (!event.target.contains(container)) return;
      disposed = true;
      clearTimeout(timer);
      if (observer) observer.disconnect();
      motion.removeEventListener('change', sync);
      if (connection && connection.removeEventListener) connection.removeEventListener('change', sync);
      document.removeEventListener('visibilitychange', sync);
      document.removeEventListener('shopify:section:unload', unload);
      if (button) button.removeEventListener('click', toggle);
    }
    document.addEventListener('shopify:section:unload', unload);
    sync();
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-drag-turn]').forEach(init); }
  return { init: init, initAll: initAll };
});
